module.exports = __webpack_public_path__ + "img/644eb04.jpg";